export const Comments = () => {
    return(
        <div>
            <h2>Comments</h2>
            <p>Comments section coming soon!</p>
        </div>
    )
}
